import { Tenant, TenantKind } from '@code/authzed-common/src/types/tenant';
import { faProjectDiagram } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from '@material-ui/core/Avatar';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React from "react";
import stc from 'string-to-color';

interface styleProps {
    avatarColor: string
    large: boolean | undefined
    kind: TenantKind
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        avatar: {
            height: (props: styleProps) => props.large ? '3rem' : '1.5rem',
            width: (props: styleProps) => props.large ? '3rem' : '1.5rem',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& svg': {
                marginRight: 0
            },
        },
    }));

/**
 * Defines the properties for the TenantLogo.
 */
interface TenantLogoProps {
    /**
     * The tenant.
     */
    tenant: Tenant;

    /**
     * className is the custom CSS class name for this component, if any.
     */
    className?: string

    /**
     * large indicates the logo should be large.
     */
    large?: boolean
}

export default function TenantLogo(props: TenantLogoProps) {
    let avatarColor = stc(props.tenant.slug);
    const classes = useStyles({ 'avatarColor': avatarColor, 'large': props.large, 'kind': props.tenant.kind });

    return <Avatar variant="rounded" className={`${classes.avatar} ${props.className || ''}`}>
        <span style={{ color: avatarColor }}><FontAwesomeIcon icon={faProjectDiagram} size={props.large ? '1x' : 'xs'} /></span>
    </Avatar>
}